import { useEffect } from 'react';
export const useRefreshCurrentIndex = ({ options, optionsAreOpen, setCurrentIndex, currentIndex, }) => {
    useEffect(() => {
        if (options.length > 0 && optionsAreOpen) {
            setCurrentIndex(0);
        }
    }, [optionsAreOpen]);
    useEffect(() => {
        if (currentIndex != null && options.length - 1 < currentIndex && options.length > 0)
            setCurrentIndex(0);
    }, [options, currentIndex]);
};
